import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import {
  default as MuiMenu,
  type MenuProps as MuiMenuProps,
} from '@mui/material/Menu';
import MenuList from '@mui/material/MenuList';
import MenuItem from './MenuItem';
import BaseMenuItem from './BaseMenuItem';
import MenuDivider from './MenuDivider';
import { classes, styles } from './utils';

export { MenuItem, BaseMenuItem, MenuDivider };

export interface MenuProps extends PropsWithChildren {
  open: boolean;
  autoFocus?: boolean;
  className?: string;
  style?: MuiMenuProps['sx'];
  listClassName?: string;
  anchorTo: HTMLElement | null;
  anchorOrigin?: MuiMenuProps['anchorOrigin'];
  transformOrigin?: MuiMenuProps['transformOrigin'];
  onClose: () => void;
}

export default function Menu({
  anchorOrigin = { horizontal: 'right', vertical: 'bottom' },
  transformOrigin = { horizontal: 'right', vertical: 'top' },
  className,
  listClassName,
  style = {},
  ...props
}: MenuProps) {
  if (!props.anchorTo) return null;
  return (
    <MuiMenu
      open={props.open}
      autoFocus={props.autoFocus}
      sx={{ ...styles.menu, ...style }}
      anchorEl={props.anchorTo}
      slotProps={{ paper: { className: twMerge(classes.paper, className) } }}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={props.onClose}>
      <MenuList className={listClassName}>{props.children}</MenuList>
    </MuiMenu>
  );
}
